import { useTranslation } from 'react-i18next';
import Dialog from '../../../../../../../common/widgets/Dialog';
import Icons from '../../../../../../../common/widgets/Icons';
import { resources } from '../../../../../resources/resources';
import Button from '../../../../../../../common/widgets/Button';

interface ApproveTimesheetDialogProps {
  close: () => void;
  approve: () => void;
  isApproving: boolean;
}

export default function ApproveTimesheetDialog(
  props: Readonly<ApproveTimesheetDialogProps>,
) {
  const { t: translate } = useTranslation();
  const { close, approve, isApproving } = props;
  return (
    <Dialog
      closeDialog={() => close()}
      showCloseIcon
      closeOnClickOutside
      className="dialog-s"
    >
      <div className="dialog-content">
        <div className="dialog-image">
          <Icons.HelpRed />
        </div>
        <div className="dialog-title">
          {translate(resources.admin.timesheets.approveDialog.title)}
        </div>
        <div className="dialog-text centered">
          {translate(resources.admin.timesheets.approveDialog.description)}
        </div>
      </div>
      <div className="dialog-actions vertical">
        <Button
          className="btn btn-solid"
          onClick={() => approve()}
          loading={isApproving}
        >
          {translate(resources.admin.timesheets.approveDialog.action)}
        </Button>
        <Button className="btn btn-outline" onClick={() => close()}>
          {translate(resources.admin.timesheets.approveDialog.back)}
        </Button>
      </div>
    </Dialog>
  );
}
